module.exports = __webpack_public_path__ + "img/card_shadow_bottom_right.b061ba65.svg";